// Copyright (c) StrangeBee 2024

import { ColumnTitle } from '@Atoms/ColumnTitle/ColumnTitle';
import { DisplayTags } from '@Atoms/Display';
import ExternalLink from '@Atoms/ExternalLink/ExternalLink';
import { simpleMarkdown } from '@Helpers/string';
import THTable from '@Molecules/THTable/THTable';
import React, { ReactElement } from 'react';

export const useExtractData = (columsTrad: Record<string, string>): Record<string, any> => {
    return {
        name: { name: columsTrad['attackPattern.preview.name'] },
        'extraData.parent.name': { name: columsTrad['attackPattern.preview.nameParent'] },
        url: { name: columsTrad['attackPattern.preview.url'], render: ExternalLink },
        dataSources: { name: columsTrad['attackPattern.preview.dataSources'] },
        defenseBypassed: { name: columsTrad['attackPattern.preview.defenseBypassed'] },
        permissionsRequired: { name: columsTrad['attackPattern.preview.permissionsRequired'] },
        systemRequirements: { name: columsTrad['attackPattern.preview.systemRequirements'] },
        remoteSupport: { name: columsTrad['attackPattern.preview.remoteSupport'] },
        'extraData.parent.capecId': { name: columsTrad['attackPattern.preview.capecId'] },
        'extraData.parent.capecUrl': {
            name: columsTrad['attackPattern.preview.capecUrl'],
            render: ExternalLink,
        },
        description: {
            name: columsTrad['attackPattern.preview.description'],
            className: 'info-description',
            render: (desc: string): ReactElement => <div dangerouslySetInnerHTML={{ __html: simpleMarkdown(desc) }} />,
        },
        'extraData.children': {
            isForce: false,
            name: columsTrad['attackPattern.preview.children'],
            className: 'info-description',
            render: (dataSource: any[]): ReactElement => (
                <THTable
                    dataSource={dataSource}
                    rowKey="patternId"
                    columns={[
                        {
                            title: <ColumnTitle>{columsTrad['attackPattern.preview.patternId']}</ColumnTitle>,
                            dataIndex: 'patternId',
                            key: 'patternId',
                            render: (patternId, data): ReactElement => (
                                <ExternalLink url={data.url}>{patternId}</ExternalLink>
                            ),
                        },
                        { title: <ColumnTitle>Name</ColumnTitle>, dataIndex: 'name', key: 'name' },
                        {
                            title: <ColumnTitle>{columsTrad['attackPattern.preview.tactics']}</ColumnTitle>,
                            dataIndex: 'tactics',
                            key: 'tactics',
                            render: (tactics): ReactElement =>
                                tactics.length !== 0 ? <DisplayTags tags={tactics} /> : <i>--</i>,
                        },
                    ]}
                />
            ),
        },
    };
};
